import React from "react";

// Import images
import shopifyChatManual from "../../assets/img/features/Shopify Chat_ Manual & AI.png";
import announceGif from "../../assets/img/announce.gif";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { Link } from "react-router-dom";

const AIChat = () => {
  return (
    <div>
      <Header />
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div
          className="container text-center py-5"
          style={{ maxWidth: "900px" }}
        >
          <h4
            className="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Shopify Chat & AI Assistance
          </h4>
          <ol
            className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          >
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item active text-primary">
              Shopify Chat & AI Assistance
            </li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-white p-50">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-4 col-lg-4">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={shopifyChatManual}
                    className="img-fluid rounded w-45"
                    alt="Shopify Chat Manual"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-8 col-lg-8 pt-120">
              <h1>Seamless Customer Support for Your Shopify Store</h1>
              <p className="font-size-p">
                Elevate your eCommerce experience with our Shopify app, designed
                to provide real-time customer interaction, AI-driven automation,
                and chatbot support. Whether you prefer manual chat, AI-powered
                assistance, or a smart chatbot, our solution ensures faster
                responses, improved customer engagement, and higher conversions.
              </p>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* Key Features & Benefits Section */}
      <header className="sub-heading-section">
        <h1>Key Features & Benefits</h1>
      </header>
      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              Manual Chat for Personalized Support
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Engage with customers in
                real-time through live chat.
              </li>
              <li>
                <span className="icon-box"></span> Direct customer queries to
                human agents when needed.
              </li>
              <li>
                <span className="icon-box"></span> Multi-agent support to handle
                high chat volumes efficiently.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">AI-Powered Chat Assistance</h2>
            <ul>
              <li>
                <span className="icon-box"></span> AI-driven recommendations for
                product suggestions & order tracking.
              </li>
              <li>
                <span className="icon-box"></span> Instant responses to
                frequently asked questions, reducing response time.
              </li>
              <li>
                <span className="icon-box"></span> AI-enhanced sentiment
                analysis to prioritize urgent queries.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">Smart Chatbot for 24/7 Automation</h2>
            <ul>
              <li>
                <span className="icon-box"></span> Automated chat responses for
                common inquiries like shipping, refunds & product details.
              </li>
              <li>
                <span className="icon-box"></span> Seamless handover to human
                agents when personalized assistance is required.
              </li>
              <li>
                <span className="icon-box"></span> Multilingual support for a
                global customer base.
              </li>
            </ul>
          </div>
          <div className="col-lg-12 mb-4">
            <h2 className="section-title">
              Shopify Integration & Advanced Features
            </h2>
            <ul>
              <li>
                <span className="icon-box"></span> Direct order tracking &
                support within chat.
              </li>
              <li>
                <span className="icon-box"></span> Customizable chat bot flows
                to match business needs.
              </li>
              <li>
                <span className="icon-box"></span> AI-powered product
                recommendations & upselling.
              </li>
            </ul>
          </div>
        </div>

        {/* Call to Action Section */}
        <section className="cta-section">
          <h2>
            <img src={announceGif} className="w-50px" alt="announcement" />{" "}
            Upgrade Your Shopify Store with AI-Powered Chat Today!
          </h2>
          <p className="font-size-p">
            Empower your store with real-time chat, AI automation, and chatbot
            support for an unmatched shopping experience! 🚀
          </p>
        </section>

        {/* Contact Information Section */}
        <div className="row g-4 mb-5">
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-map-marker-alt fa-2x"></i>
              </div>
              <div>
                <h4>Website</h4>
                <p className="mb-0">
                  <a href="https://epic-x.io/">epic-x.io</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fas fa-envelope fa-2x"></i>
              </div>
              <div>
                <h4>Mail Us</h4>
                <p className="mb-0">techsupport@epic-x.io</p>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
            <div className="contact-add-item">
              <div className="contact-icon text-primary mb-4">
                <i className="fa fa-phone-alt fa-2x"></i>
              </div>
              <div>
                <h4>Call Us</h4>
                <p className="mb-0">+91-8925696660</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default AIChat;
